import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinpune() {



    const cardData = {

keyword: "Swift Dzire On Rent in Pune",

headingDescription:
    "Rising Cab Service offers safe, affordable, and comfortable Swift Dzire On Rent in Pune for city travel, airport transfers, family trips, corporate rides, and outstation journeys. Our well-maintained Swift Dzire sedans come with clean interiors, smooth AC, experienced chauffeurs, and excellent fuel efficiency for budget-friendly travel. With doorstep pickup across Pune, flexible rental options, one-way and round-trip services, 24/7 support, and transparent pricing, we ensure a reliable and hassle-free travel experience for individuals and small families.",

topPlaces: [
    {
        title: "Lonavala & Khandala Budget Trip",
        description:
            "Lonavala and Khandala are the most popular weekend getaways near Pune, known for green valleys, waterfalls, and scenic viewpoints. Swift Dzire is ideal for couples and small families looking for an affordable and comfortable ride for short monsoon trips and relaxing hill station visits."
    },
    {
        title: "Mahabaleshwar & Panchgani Tour",
        description:
            "Mahabaleshwar and Panchgani are famous hill stations known for strawberry farms, lakes, and viewpoints. Swift Dzire provides a budget-friendly and comfortable travel option for small families and couples exploring scenic attractions and cool weather destinations."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is a major pilgrimage destination in Maharashtra dedicated to Sai Baba. Swift Dzire is widely used for affordable family darshan trips, offering a smooth and comfortable journey for devotees traveling from Pune."
    },
    {
        title: "Nashik & Trimbakeshwar Jyotirlinga",
        description:
            "Nashik is a spiritual city known for Trimbakeshwar Jyotirlinga, temples, and vineyards. Swift Dzire is a cost-effective option for small groups and families planning pilgrimage or leisure travel from Pune."
    },
    {
        title: "Pune Airport Transfers",
        description:
            "Swift Dzire is one of the most preferred cars for Pune airport pickup and drop services due to its affordability, comfort, and fuel efficiency. It ensures timely and smooth transfers for solo travelers and families."
    },
    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. Swift Dzire is suitable for small families planning budget-friendly spiritual tours from Pune with comfortable travel."
    },
    {
        title: "Alibaug Beach Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches and forts. Swift Dzire is ideal for couples and small families planning affordable weekend beach vacations from Pune."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by forests. Swift Dzire provides a comfortable and economical travel option for devotees and nature lovers."
    },
    {
        title: "Pune Local City Travel",
        description:
            "Swift Dzire is widely used for daily city travel in Pune including shopping, business meetings, and local sightseeing. It offers affordable comfort for personal and professional transportation needs."
    },
    {
        title: "Outstation Budget Travel",
        description:
            "Swift Dzire is a popular choice for budget outstation travel from Pune due to its mileage, comfort, and affordability. It is ideal for short and medium-distance trips across Maharashtra."
    }
],



services: [
{
name: "Swift Dzire On Rent in Pune",
description: "Rising Cab Service offers Swift Dzire On Rent in Pune for comfortable, budget-friendly, and reliable travel across city and outstation routes. Our Swift Dzire fleet is well-maintained, fuel-efficient, and ideal for family trips, solo travel, and business commuting. We provide professional chauffeurs, doorstep pickup, 24x7 availability, and transparent pricing with no hidden charges. Whether it is local travel, airport transfer, or long-distance journeys, Swift Dzire ensures smooth rides, excellent mileage, and affordable comfort for all types of passengers in Pune and nearby destinations."
},
{
name: "Dzire On Rent for Outstation",
description: "Book Dzire On Rent for Outstation travel with Rising Cab Service for safe, economical, and comfortable long-distance journeys. Our outstation Dzire cabs are driven by experienced chauffeurs who ensure smooth highway travel to destinations like Mumbai, Goa, Shirdi, Nashik, and Mahabaleshwar. We offer flexible pickup options, clean AC vehicles, and budget-friendly pricing, making it ideal for family trips, weekend getaways, and business travel."
},
{
name: "Per Km Rate for Swift Dzire Cab",
description: "Rising Cab Service provides transparent Per Km Rate for Swift Dzire Cab in Pune for local and outstation travel. Our pricing is affordable and clearly structured with no hidden charges. Customers can choose flexible packages based on distance and travel type, ensuring cost-effective rides with clean AC vehicles and professional drivers for a smooth journey experience."
},
{
name: "Dzire Per Km Rate for Cab Booking",
description: "Check Dzire Per Km Rate for Cab Booking with Rising Cab Service for economical and reliable travel planning. We offer competitive pricing per kilometer with high-quality service, well-maintained cars, and experienced chauffeurs. This ensures affordability without compromising comfort or safety for all types of journeys."
},
{
name: "Swift Dzire Per Km Rate in Pune",
description: "Rising Cab Service offers Swift Dzire Per Km Rate in Pune designed for budget-conscious travelers seeking safe and comfortable rides. Our rates are transparent, flexible, and suitable for both local city travel and long-distance outstation trips. Enjoy hassle-free booking, clean vehicles, and professional drivers."
},
{
name: "Swift Dzire Rent Per Km Rate for Outstation",
description: "Book Swift Dzire Rent Per Km Rate for Outstation travel with Rising Cab Service for affordable long-distance transportation. We provide clear pricing per km for trips to destinations like Goa, Shirdi, Lonavala, and Mumbai, ensuring cost-effective and comfortable journeys with trained chauffeurs and AC vehicles."
},
{
name: "Swift Dzire Rent Per Day",
description: "Rising Cab Service offers Swift Dzire Rent Per Day in Pune for full-day travel needs including business meetings, city tours, weddings, and personal travel. Our daily rental packages include professional drivers, fuel-efficient cars, and flexible usage options for maximum convenience."
},
{
name: "Swift Dzire Taxi Rate Per Km",
description: "Get Swift Dzire Taxi Rate Per Km with Rising Cab Service for transparent and affordable pricing. Our per km taxi rates are designed to provide budget-friendly travel solutions without compromising safety, comfort, or service quality."
},
{
name: "Pune to Mahabaleshwar Swift Dzire Tour",
description: "Book Pune to Mahabaleshwar Swift Dzire Tour with Rising Cab Service for a comfortable hill station getaway. Enjoy scenic travel in a clean AC Dzire with experienced drivers ensuring safe mountain driving, flexible stops, and a relaxing weekend trip experience."
},
{
name: "Pune to Shirdi Swift Dzire Cab",
description: "Rising Cab Service provides Pune to Shirdi Swift Dzire Cab for a smooth and spiritual journey to Sai Baba’s holy shrine. Our service includes doorstep pickup, safe highway travel, and comfortable AC rides ideal for families and pilgrims."
},
{
name: "Pune to Lonavala Swift Dzire Cab",
description: "Book Pune to Lonavala Swift Dzire Cab for a quick and comfortable hill station trip. Our service ensures smooth travel via expressways with professional drivers, affordable pricing, and reliable AC vehicles for family and weekend trips."
},
{
name: "Pune to Ashtavinayak Swift Dzire Cab",
description: "Rising Cab Service offers Pune to Ashtavinayak Swift Dzire Cab for a peaceful religious tour covering all major Ganpati temples. Enjoy safe travel, flexible itinerary, and comfortable AC rides for a complete spiritual experience."
},
{
name: "Pune to Mumbai Airport Swift Dzire Cab",
description: "Book Pune to Mumbai Airport Swift Dzire Cab for timely and affordable airport transfers. Our service ensures punctual pickup, smooth highway travel, luggage assistance, and professional chauffeurs for stress-free airport journeys."
},
{
name: "Pune to Goa Swift Dzire Hire",
description: "Rising Cab Service provides Pune to Goa Swift Dzire Hire for budget-friendly long-distance beach trips. Enjoy safe highway travel, comfortable seating, and experienced drivers for a relaxing Goa vacation journey."
},
{
name: "Pune to Bhimashankar Swift Dzire Taxi",
description: "Book Pune to Bhimashankar Swift Dzire Taxi for a smooth temple and nature trip. Our service ensures safe ghat driving, clean AC cars, and comfortable travel for spiritual visits and weekend getaways."
},
{
name: "Swift Dzire Taxi for Outstation",
description: "Rising Cab Service offers Swift Dzire Taxi for Outstation travel across Maharashtra and nearby states. Enjoy affordable pricing, professional drivers, and comfortable AC rides for long-distance journeys."
},
{
name: "Swift Dzire for Corporate Employees",
description: "Book Swift Dzire for Corporate Employees with Rising Cab Service for daily office commutes, meetings, and business travel. We provide punctual, safe, and cost-effective transportation solutions for professionals."
},
{
name: "Cab Services for Corporate Events",
description: "Rising Cab Service provides Cab Services for Corporate Events with reliable Swift Dzire vehicles for conferences, staff transport, and business gatherings. We ensure timely service, professional drivers, and organized travel solutions for companies."
},
{
name: "Swift Dzire Rental Pune",
description: "Book Swift Dzire Rental in Pune for affordable and comfortable travel solutions. Our service includes well-maintained AC cars, experienced drivers, and flexible booking options for local and outstation journeys."
}
],

tableData: [
["Swift Dzire On Rent in Pune","Dzire On Rent for Outstation"],
["Swift Dzire Per Km Rate in Pune","Dzire Per Km Rate for Cab Booking"],
["Swift Dzire Rent Per Km Rate for Outstation","Swift Dzire Rent Per Day"],
["Swift Dzire Taxi Rate Per Km","Pune to Mahabaleshwar Swift Dzire Tour"],
["Pune to Shirdi Swift Dzire Cab","Pune to Lonavala Swift Dzire Cab"],
["Pune to Ashtavinayak Swift Dzire Cab","Pune to Mumbai Airport Swift Dzire Cab"],
["Pune to Goa Swift Dzire Hire","Pune to Bhimashankar Swift Dzire Taxi"],
["Swift Dzire Taxi for Outstation","Swift Dzire Rental Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Affordable Swift Dzire on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable Swift Dzire rental services in Pune for local travel, airport transfers, outstation tours, corporate travel, and family trips."
    },
    {
        WhyChooseheading: "Perfect Sedan for Daily and Long-Distance Travel",
        WhyChoosedescription: "Swift Dzire is one of the most preferred sedan cars due to its comfortable seating, smooth performance, fuel efficiency, and spacious interiors."
    },
    {
        WhyChooseheading: "Ideal for Airport Transfers and Business Travel",
        WhyChoosedescription: "The vehicle is widely used for Pune Airport transfers, corporate meetings, executive travel, client visits, and business transportation."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Trips",
        WhyChoosedescription: "Swift Dzire rentals are available for Pune city travel and destinations such as Mumbai, Shirdi, Nashik, Mahabaleshwar, Lonavala, Goa, Kolhapur, and more."
    },
    {
        WhyChooseheading: "Comfortable Seating with Luggage Space",
        WhyChoosedescription: "The sedan offers comfortable seating, air conditioning, ample boot space, and a pleasant travel experience for families and business travelers."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Swift Dzire pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers and Well-Maintained Cars",
        WhyChoosedescription: "Our experienced drivers and regularly serviced vehicles ensure safe travel, punctual service, and customer satisfaction."
    },
    {
        WhyChooseheading: "Best Choice for Budget-Friendly Travel",
        WhyChoosedescription: "Swift Dzire is an economical option for solo travelers, families, corporate clients, tourists, and airport passengers."
    }
]
};

const faqData = [
    {
        question: "Why is Swift Dzire a popular rental car in Pune?",
        answer: "Swift Dzire is known for its comfort, reliability, fuel efficiency, spacious seating, and affordability for local and outstation travel."
    },
    {
        question: "Can I hire a Swift Dzire for outstation trips?",
        answer: "Yes, Swift Dzire cars are available for outstation destinations across Maharashtra and neighboring states."
    },
    {
        question: "Is Swift Dzire suitable for airport transfers?",
        answer: "Yes, Swift Dzire is one of the most preferred vehicles for Pune Airport and Mumbai Airport transfers."
    },
    {
        question: "Can families book Swift Dzire for vacations?",
        answer: "Yes, the vehicle is suitable for small families, couples, and business travelers seeking comfortable transportation."
    },
    {
        question: "Do you provide Swift Dzire for corporate travel?",
        answer: "Yes, Swift Dzire is widely used for executive transportation, office meetings, client visits, and business travel."
    },
    {
        question: "Can I book Swift Dzire for one-way travel?",
        answer: "Yes, one-way and round-trip bookings are available according to customer requirements."
    },
    {
        question: "Is the vehicle air-conditioned?",
        answer: "Yes, all Swift Dzire rental vehicles are equipped with air conditioning for comfortable travel."
    },
    {
        question: "Can Swift Dzire be hired for sightseeing tours?",
        answer: "Yes, it is an excellent option for Pune sightseeing, hill station trips, pilgrimage tours, and weekend getaways."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Swift Dzire on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohit Shinde",
        feedback:
            "I booked a Swift Dzire for my Pune to Mumbai trip. The car was clean, comfortable, and the driver was professional. The journey was smooth and enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priyanka Jagtap",
        feedback:
            "We hired a Swift Dzire for airport transportation and local sightseeing. The vehicle was well-maintained, economical, and perfect for our travel needs.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Swift Dzire on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/swift-dzire-pune.jpg",
"description": "Book Swift Dzire on Rent in Pune with Rising Cab Service for affordable local and outstation travel. Ideal for airport transfers, corporate travel, and trips to Lonavala, Mahabaleshwar, Shirdi, Goa, and Ashtavinayak.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹12/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/swift-dzire-on-rent-in-pune"
}
};







    return (
        <div>

<Helmet>
  <title>Swift Dzire on Rent in Pune | Budget Cab for Outstation | +91 9272511548</title>

<meta
 name="description"
 content="Book Swift Dzire on Rent in Pune for affordable local and outstation travel. Perfect for airport transfers, corporate trips, and tours to Lonavala, Shirdi, Mahabaleshwar, Goa, and more."
/>

<meta
 name="keywords"
 content="swift dzire on rent in pune, dzire on rent for outstation, swift dzire per km rate pune, swift dzire taxi rate per km, pune to shirdi dzire cab, pune to lonavala dzire cab, pune to mumbai airport dzire cab, pune to goa dzire hire, swift dzire corporate cab pune, budget cab pune dzire"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Swiftdzireonrentinpune;